import React from "react";

import Workflows from "../components/Kanban/Workflows";

function BoardKanbanController({
  board,
  boardId,
  loading,
  workflowId,
  cards,
}) {
  if (!workflowId) {
    return null;
  }

  return (
    <Workflows
      loading={loading}
      boardId={boardId}
      boardName={board}
      cards={cards}
      workflowId={workflowId}
    />
  );
}

export default BoardKanbanController;
